import {registerDataRouterApp} from '@github-ui/react-core/register-app'

import {codeViewAppBuilder} from './config/app-builder'
import {CodeViewBlameEntrypoint} from './pages/CodeViewBlameEntrypoint'
import {CodeViewBlobEntrypoint} from './pages/CodeViewBlobEntrypoint'
import {CodeViewBlobLayout} from './pages/CodeViewBlobLayout'
import {CodeViewBlobLayoutErrorBoundary} from './pages/CodeViewBlobLayoutErrorBoundary'
import {CodeViewDeleteEntrypoint} from './pages/CodeViewDeleteEntrypoint'
import {CodeViewEditEntrypoint} from './pages/CodeViewEditEntrypoint'
import {CodeViewFileTreeLayout} from './pages/CodeViewFileTreeLayout'
import {CodeViewLayout} from './pages/CodeViewLayout'
import {CodeViewNewEntrypoint} from './pages/CodeViewNewEntrypoint'
import {CodeViewRepoEntrypoint} from './pages/CodeViewRepoEntrypoint'
import {CodeViewTreeDeleteEntrypoint} from './pages/CodeViewTreeDeleteEntrypoint'
import {CodeViewTreeEntrypoint} from './pages/CodeViewTreeEntrypoint'
import {CodeViewTreeErrorBoundary} from './pages/CodeViewTreeErrorBoundary'
import {codeViewBlameRoute} from './routes/code-view-blame-route'
import {codeViewBlobLayoutRoute} from './routes/code-view-blob-layout-route'
import {codeViewBlobRoute} from './routes/code-view-blob-route'
import {codeViewDeleteRoute} from './routes/code-view-delete-route'
import {codeViewEditRoute} from './routes/code-view-edit-route'
import {codeViewFileTreeLayoutRoute} from './routes/code-view-file-tree-layout-route'
import {codeViewLayoutRoute} from './routes/code-view-layout-route'
import {codeViewNewRoute} from './routes/code-view-new-route'
import {codeViewRepoRoute} from './routes/code-view-repo-route'
import {codeViewTreeDeleteRoute} from './routes/code-view-tree-delete-route'
import {codeViewTreeRoute} from './routes/code-view-tree-route'

export const codeViewApp = codeViewAppBuilder.createDataRouterAppFromRoutes([
  codeViewLayoutRoute.toRoute({
    Component: CodeViewLayout,
    children: [
      codeViewRepoRoute.toRoute({
        Component: CodeViewRepoEntrypoint,
      }),
      codeViewFileTreeLayoutRoute.toRoute({
        Component: CodeViewFileTreeLayout,
        children: [
          // Most specific routes first (more path segments)
          codeViewTreeDeleteRoute.toRoute({
            Component: CodeViewTreeDeleteEntrypoint,
          }),
          codeViewEditRoute.toRoute({
            Component: CodeViewEditEntrypoint,
          }),
          codeViewDeleteRoute.toRoute({
            Component: CodeViewDeleteEntrypoint,
          }),
          // Routes without :path parameter
          codeViewNewRoute.toRoute({
            Component: CodeViewNewEntrypoint,
          }),
          codeViewTreeRoute.toRoute({
            Component: CodeViewTreeEntrypoint,
            ErrorBoundary: CodeViewTreeErrorBoundary,
          }),
          codeViewBlobLayoutRoute.toRoute({
            Component: CodeViewBlobLayout,
            ErrorBoundary: CodeViewBlobLayoutErrorBoundary,
            children: [
              codeViewBlobRoute.toRoute({
                Component: CodeViewBlobEntrypoint,
              }),
              codeViewBlameRoute.toRoute({
                Component: CodeViewBlameEntrypoint,
              }),
            ],
          }),
        ],
      }),
    ],
  }),
])

registerDataRouterApp(codeViewApp)
